import amplitude from 'amplitude-js'

var amplitudeInstance;

function initializeAnalytics() {
    const apiKey = window.LibraryAware.AmplitudeApiKey;

    amplitudeInstance = amplitude.getInstance();
    amplitudeInstance.init(apiKey);
}

function logEvent(type, properties) {
    try {
        if(!amplitudeInstance)
        {
            initializeAnalytics();
        }

        amplitude.getInstance().logEvent(type, properties);
    }
    catch(e) {
        console.error(e)
    }
}

const eventTypes = {
    FOLDERS: {
        FOLDER_SETTINGS_CLICKED: "Folder: Folder Settings - clicked",
        ARCHIVE_FOLDER_CONFIRMATION_CLICKED: "Folders: Archive Folder Confirmation - clicked",
        CREATE_FOLDER_CLICKED: "Folders: Create Folder - clicked",
        CREATE_ITEM_CLICKED: "Folders: Create Item - clicked",
        DELETE_FOLDER_CONFIRMATION_CLICKED: "Folders: Delete Folder Confirmation - clicked",
        DELETE_ITEM_CONFIRMATION_CLICKED: "Folders: Delete Item Confirmation - clicked",
        DOWNLOAD_CSV_CLICKED: "Folders: Download CSV - clicked",
        FILTER_FOLDERS_CLICKED: "Folders: Filter Folders - clicked",
        FOLDER_SEARCH_CLICKED: "Folders: Folder Search - clicked",
        ITEM_CARD_MENU_CLICKED: "Folders: Item Card Menu - clicked",
        PAGINATION_OPTION_CLICKED: "Folders: Pagination Option - clicked",
        SMART_VIEW_CLICKED: "Folders: Smart View - clicked",
        SORT_FOLDERS_CLICKED: "Folders: Sort Folders - clicked",
        STAR_FOLDER_CLICKED: "Folders: Star Folder - clicked",
        STAR_ITEM_CLICKED: "Folders: Star Item",
        UNARCHIVE_FOLDER_CLICKED: "Folders: Unarchive Folder - clicked"
    }
};

export default { logEvent, eventTypes };